import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { sendWelcomeMail, sendBulkWelcomeMail } from "DashboardUserAction";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class EmailPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  closeEmailPreviewModal = (e) => {
    this.props.closeEmailPreviewModal();
  };

  closeEmailPreviewModalAndClearData = (e) => {
    this.props.clearAllData();
  };

  sendMail = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    if (this.props.emailCount === "one") {
      var { email } = this.props.appUser;
      this.props.sendWelcomeMail(
        this.props.session,
        { email: email },
        (response) => {
          this.setState({ loading: false });
          this.closeEmailPreviewModal();
          if (response.success === 1) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_sent
            );
          } else if (response.success === 3) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_error1
            );
          } else if (response.success === 4) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_error2
            );
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        }
      );
    } else {
      this.props.sendBulkWelcomeMail(
        this.props.session,
        this.props.appUser,
        (response) => {
          if (response.success === 1) {
            this.props.showSuccess("Welcome email sent successfully!");
            //   this.setState({selectedUsers:[], allCheck: false, actionOption:false});
            this.setState({ loading: false });
            this.closeEmailPreviewModalAndClearData();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
            //   this.setState({selectedUsers:[], allCheck: false, actionOption:false});
            this.setState({ loading: false });
            this.closeEmailPreviewModalAndClearData();
          }
        }
      );
    }
  };

  render() {
    let { eventcover, themecolor, eventname } = this.props.eventDetails;

    var eventCoverPreviewUrl = `${BASE_IMAGES_URL}/eventify/sample/branding/sample-prefilled-cover.jpg?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    var tmClr = "#4da1ff";
    if (eventcover) {
      eventCoverPreviewUrl = `${BASE_IMAGES_URL}/${eventcover}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }
    if (themecolor) {
      tmClr = themecolor;
    }

    let restData = window.btoa(
      JSON.stringify({
        coverUrl: eventCoverPreviewUrl,
        eventColor: tmClr.toString(),
        eventname: eventname,
      })
    );
    var user =
      this.props.emailCount === "one"
        ? this.props.appUser.username
          ? this.props.appUser.username
          : "There"
        : "User(s)";
    var url = "../../resource/email.html?name=" + user + "&data=" + restData;
    return (
      <div>
        <Modal
          show={this.props.showEmailPreviewModal}
          onHide={this.closeEmailPreviewModal}
          dialogClassName="emailPreview"
        >
          <Modal.Body>
            <div className="import-header">
              <div className="import-modal-title">Welcome Email Preview</div>
              <button
                type="button"
                className="close btn-sm btn-close "
                onClick={() => this.closeEmailPreviewModal()}
                style={{ marginTop: -25 }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div style={{ paddingTop: 20 }}>
              <iframe
                className="frame-css"
                style={{ display: "block", margin: "0 auto" }}
                scrolling="yes"
                ref="iframe"
                frameBorder="0"
                src={url}
                height={450}
                width={"100%"}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="button-theme button-theme-blue"
              loading={this.state.loading}
              onClick={this.sendMail}
            >
              Send Welcome Mail
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  sendWelcomeMail,
  sendBulkWelcomeMail,
})(EmailPreview);
